<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ResettleMemberSelect',
})
</script>
<template>
  <Select placeholder="请选择" optionLabelProp="label" showSearch optionFilterProp="label" allowClear style="width: 100%" v-bind="$attrs">
    <Select.Option v-for="item in options" :key="item.id" :label="item.userName" :disabled="getOptionDisabled(item)">
      <Option :record="item" />
    </Select.Option>
  </Select>
</template>

<script lang="ts" setup name="ResettleMemberSelect">
import { Select } from 'ant-design-vue'
import Option from './Option.vue'
import { RESETTLE_WAY } from '@/constant/biz'
import { isFunction } from '@bd/vue3-utils'
const props = withDefaults(
  defineProps<{
    options: ApiFamilyMembers.Item[]
    optionDisabled?: (record: ApiFamilyMembers.Item) => boolean
  }>(),
  {
    options: () => []
  }
)

const getOptionDisabled = (record: ApiFamilyMembers.Item) => {
  if (record.isAnZhi) return true
  if (isFunction(props.optionDisabled)) {
    return props.optionDisabled(record)
  }
  return Object.values(RESETTLE_WAY).some(k => record?.[k] === 1)
}
</script>
